import { Component, OnInit } from '@angular/core';
import { CommonConstants } from '../common/utilities/commonConstants';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  public text = '';
  public bfljourney: boolean;
  constructor(
  ) { }

  ngOnInit() {
    let url: any = window.location.pathname;
    url = url.split("/");
    this.bfljourney = url.includes(CommonConstants.QueryParamsKeys.marketplace);
    this.text = 'Creating Personalized Offers basis your Profile details';
    setTimeout(() => {
      if (!this.bfljourney)
        this.text = 'Finserv MARKETS is helping <br/> Millions of Indians to Complete <br/> their Financial Goals';
    }, 3000);

    setTimeout(() => {
      this.text = 'Wait is Over... <br/> We are almost done…';
    }, 6000);
  }

}
